<template>
    <div class="word_mobile">
        <top_mobile></top_mobile>
        <div style="height: 44px;background: #202334;width: 24rem;position: fixed;top: 0;"></div>
        <iframe style="overflow: scroll;" src="http://help.idalc.com/doku.php" id="mobs"  frameborder="0">
        </iframe>

    </div>

</template>

<script>
    import top_mobile from "../components/top_mobile";
    import botmob from "../components/botmobile";

    export default {
        name: "word_mobile",
        data() {
            return {}
        },
        components: {
            top_mobile, botmob
        },
        mounted() {

        },
        methods: {
            iframeLoad() {
                console.log(123);

            }
        },
    }
</script>

<style scoped lang='scss'>
    .word_mobile {
        position: absolute;
        top: 0;
        background: #fbfaf9;
        width: 24rem;
        height: 100%;

        #mobs {
            width: 24rem;
            margin-top: 44px;
            min-height: calc(100% - 50px);
            height: auto;
            position: relative;
        }
    }
</style>